import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import Dashboard from "./Dashboard";
import DocumentsValidated from "./DocumentsValidated";
import DocumentsInProgress from "./DocumentsInProgress";
import Preferences from "./Preferences";
import { useParams } from "react-router-dom"
import styled from "styled-components";
import { useHistory } from "react-router-dom";
// import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from "axios"
import moment from "moment"
import TempleteModel from './RecycleDocs3'
import {
  Form,
  Input,
  Checkbox,
  Select,
  InputNumber,
  Col,
  Row,
  Button,
  Radio,
  Upload,
  DatePicker,
  TimePicker,
} from "antd";
import { UploadOutlined, InboxOutlined } from "@ant-design/icons";

import { Modal, InputGroup, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText, Label } from 'reactstrap'
import { data } from "jquery";
import Loader from '../../utilities/loader';
// import { Button } from "react-bootstrap";
import { showToastAction } from "../../../redux/toastSlice";
import { useFormik } from "formik";

let Data = []

const Form1 = () => {
  const [DocData, setDocData] = useState([])
  const [collectFormData, setCollectFormData] = useState({ name: '', description: '' })
  const selectedProject = useSelector(state => state.selectedProject);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [showTemplete, setShowTemplete] = useState('')
  const [addQrCode, setAddQrCode] = useState(true)
  const [DocData1, setDocData1] = useState("")
  const [activeSceen, setActiveScreen] = useState(0)
  const [loading, setLoading] = useState(false)
  // console.log('showTemplete',showTemplete)
  // console.log("DocData1",DocData1)
  // console.log("DocData",DocData)
  // console.log("selectedProject", selectedProject);

  // console.log("window.location.search", window.location.pathname.split("/")[2]);

  useEffect(() => {
    axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/recycle/list-document-templates`).then(res => {
      console.log("res", res);
      setDocData(res?.data?.data)
    })


  }, [])

  const daydiff = (v) => {
    // console.log("v", v);

    var today = new Date();
    var date1 = moment(today).format("MM/DD/yyyy")
    let dummy = v?.split(" ")[0].split("/")
    let dummy2 = [dummy[1], dummy[0], dummy[2]].join("/")

    var date2 = new Date(dummy2);
    var timeDiff = date2.getTime() - today.getTime();
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return diffDays

  }


  const containerStyle = {
    border: "2px solid gray",
    maxHeight: "auto",
    // flex: 1,
    height: "auto",
    overflowY: `hidden`,
    padding: "20px",
    borderRadius: "5px",
    margin: "0px 7px"

  };

  //const handleInputChange = (e) => {
  //  setCollectFormData({ ...collectFormData, [e.target.name]: e.target.value });
  //};

  const dispatch = useDispatch();

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setformData] = useState({})
  // console.log("🚀 ~ file: RecycleDocs2.js ~ line 56 ~ Form1 ~ formData", formData)
  const [data, setdata] = useState(Data)

  const history = useHistory()

  const onChange = (e) => {
    const { name, value } = e.target
    setformData({
      ...formData,
      [name]: value,
    });
  }

  const formik = useFormik({
    initialValues: {
      add_qr_code: true,
    },
    onSubmit: values => {
      if (!fileError) {
        handleSubmit()
      }
    },
  });



  const handleAddOpen = () => setShowAddModal(true);
  const handleAddClose = () => setShowAddModal(false);

  const onFinish = async (values) => {
    try {
      if (!values.name) return
      setLoading(true)

      // console.log("Success:", values);
      //console.log("selectedFile1", selectedFile1);

      const formData = new FormData();
      //formData.append("name", values.name);
      //formData.append("name",handleInputChange);
      //formData.append("description", values.description);
      //formData.append("description",handleInputChange)
      //formData.append("file", selectedFile1)

      values.name && formData.append("name", values.name);
      values.description && formData.append("description", values.description);
      selectedFile1 && formData.append("file", selectedFile1);

      await axios.post(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/recycle/add-document-template`, formData).then(res => {
        setLoading(false)
        axios.get(`/project/${selectedProject?.name}/${window.location.pathname.split("/")[2]}/recycle/list-document-templates`).then(res => {
          // console.log("res", res);
          setDocData(res?.data?.data)
          handleAddClose()

        })
      })
    }

    catch (err) {
      setLoading(false)
      console.log(err)
      dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "error", showToast: true }));
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const normFile = (e) => {
    // console.log("Upload event:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const props = {
    name: 'file',
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
      authorization: 'authorization-text',
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  const handleCloseTemplete = (name) => {
    setShowTemplete(name)
    setDocData1('')
    setActiveScreen(0)
  }
  // console.log("DocData", DocData);
  return (<>
    <TempleteModel
      show={showTemplete}
      handleClose={handleCloseTemplete}
      DocData={DocData1}
      setDocData={setDocData1}
      activeSceen={activeSceen}
      setActiveScreen={setActiveScreen}
      addQrCode={formik.values.add_qr_code}
    />
    {loading && <Loader />}
    <div className="h-full flex flex-col">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Création nouveaux documents</h4>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h8>Utilisez cette section pour créer de nouveaux documents sécurisés en tirant parti des données extraites de vos documents archivés et/ou</h8>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h8>des informations insérées dans la base de données. Chaque document généré peut être protégé par un QR code (Quick Response code),</h8>
      </div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h7>vous permettant de vérifier facilement son authenticité.</h7>
      </div>

      <Form.Item>
        <Row className="mb-3" align="middle">
          <Col span={4}>
            <strong>Ajouter QR Code</strong>
          </Col>
          <Col span={16}>
            <Checkbox
              name="add_qr_code"
              checked={formik.values.add_qr_code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </Col>
        </Row>
      </Form.Item>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5>Choisir un template</h5>
        <button onClick={handleAddOpen} className="add-btn"><i className="ti-plus mr-2"></i>  Nouveau template</button>
      </div>
      {/* <h4 className="border-0 m-0 mb-3">Choose an existing template</h4> */}
      <div className="row mt-3 flex-wrap" style={containerStyle}>

        {
          DocData?.map((v, index) => {
            //</div>DocData?.map((v, index) => {
            return (
              // <div className="m-2 doc-width" onClick={() => history.push(`/recycledocs3/${window.location.pathname.split("/")[2]}/${v?.name}`)}>
              <div key={index} className="m-2 doc-width" onClick={() => setShowTemplete(v?.name)}>

                <div className="custom-card card document">
                  <div class="top"></div>

                  {daydiff(v?.creation_date) > -2 && <label className="new-badge">New!  </label>}
                  <div className="card-body">
                    <h2 className="title_doc"><strong>{v?.name}</strong></h2>
                    <h5 className="description_doc"><strong>{v?.description}</strong></h5>
                    <h5 className="text-right"><strong>{v?.created_by}</strong></h5>
                    {/* <h5 className="text-right"><strong>{v?.associated_project}</strong></h5> */}
                    <h5 className="text-right"><strong>{v?.creation_date}</strong></h5>
                    {v?.last_modification_date && <>
                      <h5 className="text-right"><strong>{v?.last_modification_date}</strong></h5></>}
                    {v?.modified_by && <>
                      <h5 className="text-right"><strong>{v?.modified_by}</strong></h5></>}
                  </div>
                </div>
              </div>)
          })
        }

        {/* <div className="col-md-6 m-5" style={containerStyle}>sss</div> */}
      </div>
    </div>
    <Modal isOpen={showAddModal} toggle={handleAddClose}>
      <Form
        name="basic"
        //   labelCol={{ span: 4 }}
        //   wrapperCol={{ span: 16 }}
        // initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        autoComplete="off"
      >
        <ModalHeader toggle={handleAddClose}>
          Add Template
        </ModalHeader>
        <ModalBody>
          <div className="flex flex-col gap-4">

            {/* <Form.Label>Template Name</Form.Label>
                            <Form.Control type="=text" name="name" placeholder="Enter Template Name" onChange={onChange}/>
                            <br />
                            <Form.Label>Description</Form.Label>
                            <Form.Control type="text" name="created" placeholder="Enter Name" onChange={onChange}/> 
                            <br /> */}
            <Form.Item
              label="Nom"
              name="name"
              rules={[{ required: true, message: "Please enter template name" }]}
            >
              <Input placeholder="Enter Template Name" />
            </Form.Item>
            <Form.Item
              name="description"
              label="Description"
              rules={[{ required: false }]}
            >
              <Input.TextArea placeholder="Enter Description" />
            </Form.Item>
            <label>Document</label>
            <input
              type="file"
              accept=".doc, .docx"
              onChange={(e) => setSelectedFile1(e.target.files[0])}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" onClick={handleAddClose}>
            Close
          </Button>
          <Form.Item>
            <Button variant="primary" htmlType="submit" onClick={onFinish}>
              Upload
            </Button>
          </Form.Item>
        </ModalFooter>
      </Form>
    </Modal>
  </>
  );
};



export default Form1;
